import XMLParser from 'react-xml-parser';

export function getContent(object, param) {
	if (param['$ref'] !== undefined) {
		let keys = param['$ref'].slice(2).split('/');
		keys.forEach(key => {
			object = object[key];
		});
		return object;
	}
	return param;
}

export function hasTags(tags, filter, type = 'any') {
	if (!filter || filter.length === 0) return type !== 'any-exclude';
	for (let i = 0; i < filter.length; i++) {
		if (tags.indexOf(filter[i]) >= 0) {
			return true;
		}
	}
	return false;
}

export function simpleTime(date) {
	let h = date.getHours().toString().padStart(2, '0'),
		m = date.getMinutes().toString().padStart(2, '0'),
		s = date.getSeconds().toString().padStart(2, '0'),
		ms = date.getMilliseconds().toString().padStart(3, '0');
	return `${h}:${m}:${s}.${ms}`;
}

export function unique(array) {
	return array.filter((value, index) => array.indexOf(value) === index);
}

export function verifyHost(hostUrl, onSuccess, onError) {
	const xhr = new XMLHttpRequest();
	xhr.onreadystatechange = () => {
		if (xhr.readyState === 4) {
			if (xhr.status === 200) {
				try {
					let response = JSON.parse(xhr.responseText);
					if (response.result !== undefined && response.result.version !== undefined) {
						// all is good
						onSuccess && onSuccess();
						return;
					}
				} catch (e) {
					onError && onError();
					return;
				}
			}
			onError && onError();
		}
	};
	xhr.open('GET', hostUrl + '/api/v2/public/test');
	xhr.send();
}

export function copyToClipboardEnabled() {
    return !!navigator?.clipboard?.writeText;
}

export function copyToClipboard(valueToCopy) {
    if(copyToClipboardEnabled()) {
        navigator.clipboard.writeText(valueToCopy).catch(e => {
            console.error(e);
        });
        return true;
    }
    return false;
}

export function unwrapItem(item) {
    let content = item ? item.message : undefined;
    let headers;
    if (content !== undefined && (typeof content) === 'object' && content.content !== undefined) {
        headers = content.headers;
        content = content.content;
    }
    return {content, headers};
}

export function renderItem(item) {
    let {content, headers} = unwrapItem(item);
    return (
        (headers !== undefined ? headers + '-'.repeat(80) + '\n' : '') +
        (((typeof content) === 'object' ? JSON.stringify(content, null, 2) : content) || '')
    );
}

function getParamField(messageData, xml_fields, groupName = '') {
    const fieldData = xml_fields.find(field => field.attributes.name === messageData.attributes.name);
    if (!fieldData) {
        throw new Error(`[getFixSpecs] - Could not find param specs for ${ messageData.attributes.name }`);
    }

    const name = fieldData.attributes.name;
    const type = fieldData.attributes.type;
    const number = fieldData.attributes.number;
    const description = messageData.attributes.description || '';
    const required = messageData.attributes.required === 'Y';

    const values = fieldData.children?.map(value => ({
        value: value.attributes.enum,
        description: value.attributes.description,
    }));

    const param = { name, type, number, required, description };

    if (values?.length) {
        param.values = values;
    }

    if (groupName) {
        param.groupName = groupName;
    }

    return param;
}

function getMessageParams(message, xml_fields, groupName = '') {
    return message.map(messageData => {
        if (messageData.name === 'field') {
            return getParamField(messageData, xml_fields, groupName);
        } else if (messageData.name === 'group') {
            const groupControl = messageData;

            const { name, type, number, required, description } = getParamField(groupControl, xml_fields);
            return {
                name,
                type,
                required,
                number,
                description,
                groupRequired: groupControl.attributes.required === 'Y',
                groupName: groupControl.attributes.name,
                parameters: getMessageParams(groupControl.children, xml_fields, groupControl.attributes.name),
            };
        }
    });
}

function populateMessages(message, components) {
    const newChildren = [];
    message.children.forEach(child => {
        if (child.name === 'component') {
            const componentFields = components.find(component => component.attributes.name === child.attributes.name).children;
            componentFields.forEach(component => populateMessages(component, components));

            newChildren.push(...componentFields);
        } else {
            newChildren.push(child);
        }
    });

    message.children = newChildren;
}

function cleanXml(xml) {
    return xml.replace(/<!--[\s\S]*?-->/g, '');
}
export function getFixSpecs(xml) {
    xml = cleanXml(xml);
    const allowedSources = ['client', 'both'];
    const parser = new XMLParser();
    const docs = parser.parseFromString(xml);

    const xml_messages = docs.children.find(child => child.name === 'messages').children;
    const xml_fields = docs.children.find(child => child.name === 'fields').children;
    const xml_components = docs.children.find(child => child.name === 'components').children;

    const allowedMessages = xml_messages.filter(message => allowedSources.includes(message.attributes.source));
    allowedMessages.forEach(message => populateMessages(message, xml_components));

    return {
        messages: allowedMessages.map(message => {
            const messageType = message.attributes.msgtype;
            const name = `${ message.attributes.name } (${ messageType })`;
            const description = message.attributes.description;
            const category = message.attributes.msgcat;
            const parameters = getMessageParams(message.children, xml_fields);

            return {
                name,
                messageType,
                category,
                description,
                parameters,
            };
        }),
    };
}

export function FixParamIsGroup(parameter) {
    return !!parameter.parameters;
}

export function safeJsonParse(text) {
  return JSON.parse(text, (_key, value, context) => {
    if (Number.isInteger(value) && !Number.isSafeInteger(value)) {
      return context.source;
    }
    return value;
  });
}
